'use strict';
import React from 'react';
import flux from 'utils/flux';
import trunc from 'lodash/string/trunc';
import Immutable from 'immutable';
import Thumb from 'components/thumb';
import { Navigation } from 'react-router';
import prettyBytes from 'pretty-bytes';

var ShareItem = React.createClass({
    displayName: 'ShareItem',

    mixins: [
        Navigation
    ],

    propTypes: {
        media: React.PropTypes.object
    },

    shouldComponentUpdate(nextProps) {
        return (Immutable.is(nextProps.item, this.props.item) === false);
    },

    generateQuickDownload(e) {
        e.preventDefault();
        flux.getStore('basket').createBasket([{id: this.props.item.get('id')}]).then(() => {
            setTimeout(() => {
                var activeBasketId = flux.getStore('basket').getState().activeBasketId;
                this.transitionTo( 'singleBasket', { id: activeBasketId });
            }, 20);
        });
    },

    generateInstantDownload(e) {
        e.preventDefault();
        flux.getActions('modals').openInstantDownloadModal(this.props.item);
    },

    toggleCheck(size = undefined, e) {
        e.preventDefault();
        var pageParams = this.context.router.getCurrentParams();
        var basketId = this.props.basketId;
        flux.getActions('share').toggleItemSelection({ basketId: basketId, itemId: this.props.item.get('id'), fileKey: size });
    },

    render() {
        var item = this.props.item.toJS();
        const { shareMode } = flux.getStore('app').getState().config.toJS();
        const isAuthenticated = flux.getStore('app').isAuthenticated();


        const { meta } = item;
        const { files } = item;
        const master = files.find( file => 'master' === file.key ) || ( files.length && files[0] );
        const MICode = meta.find( meta => 'MICode' === meta.key );
        const duration = master && master.meta && master.meta.find && master.meta.length > 0 && master.meta.find( meta => 'Duration' === meta.name );
        let listItem = ('openDownload' !== shareMode && !('auth' === shareMode && isAuthenticated)) ?
            <div className="listing__item">
                <Thumb className="item__preview" media={this.props.item} onClickOpenModal={true} isSharedItem={true} />
                <div className="item__info">
                    <div className="info__top">
                        <h4 className="top__title" style={{paddingLeft: (('auth' === shareMode || 'openDownload' === shareMode || ('noAuth' === shareMode && isAuthenticated)) ? null : '0')}}>
                            {item.title}
                        </h4>
                    </div>
                    <div className="item__description">
                        {trunc(item.description, 120)}
                    </div>
                    <div className="item__additional">{item.additionalText}</div>
                </div>
            </div>
        :
            <div className="basket__item">
                <div className="item__image">
                    <Thumb className="item__preview" media={this.props.item} onClickOpenModal={true} isSharedItem={true} />
                </div>
                <div className="item__description">
                    <div className="description__title">
                        {item.title.length ? item.title : '&nbsp;'}
                    </div>

                    <div className="description__meta">
                        {MICode && MICode.value.length > 0 && <span className="meta__id">{MICode.value}</span>}
                        {duration && duration.value.length > 0 && <span className="meta__duration">{duration.value}</span>}
                    </div>

                    <div className="description__download">
                        <form>
                            <table>
                                <thead>
                                    <th className="download__head--checkbox">&nbsp;</th>
                                    <th>{flux.t('download_file_format')}</th>
                                    <th>{flux.t('download_file_mimetype')}</th>
                                    <th>{flux.t('download_file_size')}</th>
                                </thead>
                                <tbody>
                                    {item.files.map( file => {
                                        var dimensions = file.meta && file.meta.length > 0 && file.meta.find( meta => !meta.hidden && 'Dimensions' === meta.name );
                                        return (
                                            <tr key={'i-' + item.id + '-' + file.key}>
                                                <td className="file__key download__body--checkbox">
                                                    <div className="field__checkbox download__checkbox">
                                                        <input id="check__all" checked={file._download} type="checkbox" readOnly />
                                                        <label onClick={this.toggleCheck.bind(null, file.name)} htmlFor="check__all">{file.name}</label>
                                                    </div>
                                                </td>
                                                <td className="file__dimensions">{dimensions && dimensions.value}</td>
                                                <td className="file__mimetype">{file.mimeType}</td>
                                                <td className="file__size">{prettyBytes(file.size)}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        ;

        return listItem;
    }
});

module.exports = ShareItem;



// WEBPACK FOOTER //
// ./app/pages/share/shareItem.jsx